import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter';
import DXFilterConfig from '../DXFilterConfig';
import constants from '../../constants';

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXActivityFilter extends React.Component {
  render() {
    const { selected, onChange, intl, equality } = this.props;
    const config = DXActivityFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter
        selected={selected}
        title={config.title}
        values={config.values}
        onChange={onChange}
        multi={config.multi}
      />
    );
  }
}

DXActivityFilter.propTypes = propTypes;
DXActivityFilter.defaultProps = defaultProps;
DXActivityFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'filter.active.', selectedValues);
};
DXActivityFilter.applyToQueryParams = (queryParams, selectedValues) => {
  selectedValues[0] && (queryParams['active'] = selectedValues[0]);
  return queryParams;
};
DXActivityFilter.getConfig = (intl, equality) => {
  let config = new DXFilterConfig({
    name: 'activity',
    selected: [],
    property: 'active',
    title: intl.formatMessage({ id: 'prepurchases.column.status' }),
    disabled: false,
    equalityStatus: false,
    multi: false,
  });

  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('true', intl.formatMessage({ id: 'filter.active.true' }));
    config.addFilterValue('false', intl.formatMessage({ id: 'filter.active.false' }));
  }

  return config;
};

DXActivityFilter.getInitialConfig = (intl, values, readOnly, invisible) => {
  return {
    name: 'activity',
    title: intl.formatMessage({ id: 'prepurchases.column.status' }),
    property: 'active',
    type: 'activity',
    selectedValues: values,
    clientSide: false,
    readOnly: readOnly ? readOnly : false,
    fromVariable: !!invisible || false,
  };
};

export default injectIntl(DXActivityFilter);
